import { performRequest} from './api-handler';
import { URLS } from '../utility/urls'

export default () => {
    const { GET_SERVER_DATE_TIME } = URLS;
    return {
        getServerDateTime: (body={}, method='get') =>
         performRequest( method ? method:'get', GET_SERVER_DATE_TIME, body ),
    }
}